module.exports = __webpack_public_path__ + "static/media/deck-carousel-3.6007c94a.gif";